var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-toolbar",
        { attrs: { dark: "", color: "primary", fixed: "" } },
        [
          _c(
            "v-toolbar-title",
            {
              staticClass: "toolbar-title font-bold white--text",
              class: { divider: !_vm.isMobile }
            },
            [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "v-tooltip",
            { attrs: { disabled: !_vm.showTooltip, bottom: "" } },
            [
              !_vm.isMobile && _vm.showSchedulerButton
                ? _c(
                    "v-btn",
                    {
                      staticClass: "toolbar-item",
                      class: { active: _vm.isOnScheduler },
                      attrs: { slot: "activator", flat: "" },
                      on: { click: _vm.goToScheduler },
                      slot: "activator"
                    },
                    [_vm._v("\n        Schedule\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("span", [_vm._v("Go to Scheduler Dashboard")])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tooltip",
            { attrs: { disabled: !_vm.showTooltip, bottom: "" } },
            [
              !_vm.isMobile && _vm.showSLButton
                ? _c(
                    "v-btn",
                    {
                      staticClass: "toolbar-item",
                      class: { active: _vm.isOnServiceLogs },
                      attrs: { slot: "activator", flat: "" },
                      on: { click: _vm.goToServiceLogs },
                      slot: "activator"
                    },
                    [_vm._v("\n        Service Logs\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("span", [_vm._v("Go to Service Log Dashboard")])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tooltip",
            { attrs: { disabled: !_vm.showTooltip, bottom: "" } },
            [
              !_vm.isMobile && _vm.showSLButton
                ? _c(
                    "v-btn",
                    {
                      staticClass: "toolbar-item",
                      class: { active: _vm.isOnSearchLogs },
                      attrs: { slot: "activator", flat: "" },
                      on: { click: _vm.goToSearchServiceLogs },
                      slot: "activator"
                    },
                    [_vm._v("\n        Search Logs\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("span", [_vm._v("Go to Search Service Logs")])
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c("span", { staticClass: "subheading font-weight-medium pr-2" }, [
            _vm._v("\n      " + _vm._s(_vm.fullName) + "\n    ")
          ]),
          _vm._v(" "),
          _c(
            "v-menu",
            {
              attrs: {
                transition: "slide-y-transition",
                "open-on-hover": "",
                "offset-y": ""
              }
            },
            [
              _c(
                "v-btn",
                {
                  attrs: { slot: "activator", dark: "", icon: "" },
                  slot: "activator"
                },
                [_c("v-icon", [_vm._v("more_vert")])],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list",
                [
                  _c(
                    "v-list-tile",
                    {
                      on: {
                        click: function($event) {
                          _vm.showDialog = true
                        }
                      }
                    },
                    [
                      _c("v-icon", { staticClass: "pr-3" }, [
                        _vm._v("settings")
                      ]),
                      _vm._v("\n          User Preferences\n        ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showSLButton
                    ? _c(
                        "v-list-tile",
                        {
                          on: {
                            click: function($event) {
                              return _vm.openTab(_vm.serviceLogsHelpUrl)
                            }
                          }
                        },
                        [
                          _c("v-icon", { staticClass: "pr-3" }, [
                            _vm._v("help")
                          ]),
                          _vm._v("\n          PT Service Logs Help\n        ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showSchedulerButton
                    ? _c(
                        "v-list-tile",
                        {
                          on: {
                            click: function($event) {
                              return _vm.openTab(_vm.schedulerHelpUrl)
                            }
                          }
                        },
                        [
                          _c("v-icon", { staticClass: "pr-3" }, [
                            _vm._v("help")
                          ]),
                          _vm._v("\n          PT Scheduler Help\n        ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-list-tile",
                    { on: { click: _vm.logout } },
                    [
                      _c("v-icon", { staticClass: "pr-3" }, [
                        _vm._v("exit_to_app")
                      ]),
                      _vm._v("\n          Logout\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showDialog
        ? _c(
            "div",
            [
              _c("user-preferences", {
                on: {
                  "dialog:closed": function($event) {
                    _vm.showDialog = false
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c2a23fca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2a23fca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toolbar.vue
// module id = null
// module chunks = 